import { Navigate, Route, Routes } from 'react-router';
import { AppShell } from './components/layout/AppShell';
import { ManagementShell } from './components/layout/ManagementShell';
import { ROLE_ADMIN, ROLE_AUTHENTICATED, ROLE_AUTHOR } from './config/areas';
import { LandingPage } from './pages/LandingPage';
import { NotFoundPage, NotFoundSection } from './pages/NotFoundPage';
import { DraftsPage } from './pages/app/DraftsPage';
import { TemplatePickerPage } from './pages/app/TemplatePickerPage';
import { WizardPage } from './pages/app/WizardPage';
import { ServicesPage } from './pages/settings/ServicesPage';
import { TemplateDetailPage } from './pages/studio/TemplateDetailPage';
import { TemplateListPage } from './pages/studio/TemplateListPage';
import { CategoriesPage } from './pages/studio/CategoriesPage';
import { ReferenceDataPage } from './pages/studio/ReferenceDataPage';
import { SystemPropertiesPage } from './pages/studio/SystemPropertiesPage';
import { PropertyEditorPage } from './pages/studio/PropertyEditorPage';
import { TemplateVersionsPage } from './pages/studio/TemplateVersionsPage';
import { InsightsPage } from './pages/settings/InsightsPage';
import { UsersPage } from './pages/settings/UsersPage';
import { ReferenceEntryPage } from './pages/studio/ReferenceEntryPage';
import { ClaudeCodeSetupPage } from './pages/studio/ClaudeCodeSetupPage';
import { SlideLibraryPage } from './pages/studio/SlideLibraryPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />

      {/* Documents — authenticated */}
      <Route element={<AppShell requiredRoles={[ROLE_AUTHENTICATED]} />}>
        <Route path="/app" element={<Navigate to="/app/new" replace />} />
        {/* Generated documents are kept server-side but not listed; old links land on the template list. */}
        <Route path="/app/documents/*" element={<Navigate to="/app/new" replace />} />
        <Route path="/app/drafts" element={<DraftsPage />} />
        <Route path="/app/new" element={<TemplatePickerPage />} />
        <Route path="/app/new/:templateId" element={<Navigate to="details" replace />} />
        <Route path="/app/new/:templateId/:step" element={<WizardPage />} />
        <Route path="/app/*" element={<NotFoundSection />} />
      </Route>

      {/* Template Studio — admin, author */}
      <Route element={<ManagementShell requiredRoles={[ROLE_ADMIN, ROLE_AUTHOR]} />}>
        <Route path="/studio" element={<Navigate to="/studio/templates" replace />} />
        <Route path="/studio/templates" element={<TemplateListPage />} />
        <Route path="/studio/templates/:templateId" element={<TemplateDetailPage />} />
        <Route
          path="/studio/templates/:templateId/properties"
          element={<PropertyEditorPage />}
        />
        <Route
          path="/studio/templates/:templateId/versions"
          element={<TemplateVersionsPage />}
        />
        <Route path="/studio/reference" element={<ReferenceDataPage />} />
        <Route path="/studio/reference/categories" element={<CategoriesPage />} />
        <Route path="/studio/reference/system" element={<SystemPropertiesPage />} />
        <Route
          path="/studio/reference/:entryId"
          element={<ReferenceEntryPage />}
        />
        <Route path="/studio/claude-code" element={<ClaudeCodeSetupPage />} />
        <Route path="/studio/slide-library" element={<SlideLibraryPage />} />
        <Route path="/studio/*" element={<NotFoundSection />} />
      </Route>

      {/* Administration — admin */}
      <Route element={<ManagementShell requiredRoles={[ROLE_ADMIN]} />}>
        <Route path="/settings" element={<Navigate to="/settings/services" replace />} />
        <Route path="/settings/services" element={<ServicesPage />} />
        <Route path="/settings/insights" element={<InsightsPage />} />
        <Route path="/settings/users" element={<UsersPage />} />
        <Route path="/settings/*" element={<NotFoundSection />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
